import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="loadingService.loading$ | async" class="global-loading-overlay">
      <div class="loading-container">
        <p-progressSpinner 
          [style]="{ width: '50px', height: '50px' }" 
          strokeWidth="4"
          animationDuration=".8s">
        </p-progressSpinner>
      </div>
    </div>
  `,
  styles: [`
    .global-loading-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      pointer-events: none;
    }

    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }

    .loading-container p-progressSpinner {
      color: var(--primary-color);
    }
  `]
})
export class GlobalLoadingComponent {
  constructor(public loadingService: LoadingService) {}
}